import React from "react";

// --- NEW COMPONENT: Floating Logo Wall (Matches Enterprise Design) ---
const IntegrationsBanner = () => {
  const marqueeStyle = {
    display: "flex",
    width: "max-content",
    animation: "marquee 60s linear infinite",
  };

  const marqueeReverseStyle = {
    display: "flex",
    width: "max-content",
    animation: "marqueeReverse 60s linear infinite",
  };

  return (
    <div className="w-full py-20 border-t border-gray-400">
      <div className="w-full max-w-7xl mx-auto px-4">
        <div className="relative w-full overflow-hidden bg-transparent group">
          <style>{`
            @keyframes marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
            @keyframes marqueeReverse {
              0% { transform: translateX(-50%); }
              100% { transform: translateX(0); }
            }
            .mask-gradient {
              mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
              -webkit-mask-image: linear-gradient(to right, transparent, black 10%, black 90%, transparent);
            }
          `}</style>

          <div className="relative z-20 text-center max-w-3xl mx-auto px-4 mb-12">
            <h2 className="text-3xl md:text-3xl font-semibold text-gray-900 mb-6 not-italic">
              Unified Data Intelligence
            </h2>
            <p className="text-gray-600 text-sm md:text-sm non-italic">
              Seamlessly integrating with your existing data ecosystem.
            </p>
          </div>

          <div className="flex flex-col gap-6 mask-gradient">
            {/* ROW 1 */}
            <div className="w-full overflow-hidden">
              <div style={marqueeStyle}>
                {[...Array(4)].map((_, i) => (
                  <img
                    key={i}
                    src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1764852824/sass-group-one_ztrkcs.svg"
                    alt="SaaS Integrations Group 1"
                    // UPDATED: Reduced height to h-12 md:h-16 and margin to mx-4
                    className="h-12 md:h-16 mx-4 flex-shrink-0 max-w-none opacity-90 hover:opacity-100 transition-opacity"
                  />
                ))}
              </div>
            </div>
            {/* ROW 2 */}
            <div className="w-full overflow-hidden">
              <div style={marqueeReverseStyle}>
                {[...Array(4)].map((_, i) => (
                  <img
                    key={i}
                    src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1764852824/sass-group-two_p6xxs7.svg"
                    alt="SaaS Integrations Group 2"
                    // UPDATED: Reduced height to h-12 md:h-16 and margin to mx-4
                    className="h-12 md:h-16 mx-4 flex-shrink-0 max-w-none opacity-90 hover:opacity-100 transition-opacity"
                  />
                ))}
              </div>
            </div>
            {/* ROW 3 */}
            <div className="w-full overflow-hidden">
              <div style={marqueeStyle}>
                {[...Array(4)].map((_, i) => (
                  <img
                    key={i}
                    src="https://res.cloudinary.com/dpn3bkjba/image/upload/v1764852825/llm-group-one_atusht.svg"
                    alt="LLM Integrations"
                    // UPDATED: Reduced height to h-12 md:h-16 and margin to mx-4
                    className="h-12 md:h-16 mx-4 flex-shrink-0 max-w-none opacity-90 hover:opacity-100 transition-opacity"
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
// --- ICONS (Styled like Enterprise) ---
const PerformanceIcon = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    </svg>
  </div>
);

const ThreatIcon = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12h20M12 2v20" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  </div>
);

const IdentityIcon = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
      <circle cx="12" cy="7" r="4"></circle>
    </svg>
  </div>
);

const AIBehaviorIcon = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  </div>
);
// ★ THIS WAS MISSING IN YOUR PREVIOUS FILE ★
const AIPerformanceIcon = (
  <div className="w-16 h-16 bg-green-900 rounded-2xl flex items-center justify-center mb-6 shadow-lg shadow-emerald-500/30">
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="white"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
      <line x1="8" y1="21" x2="16" y2="21" />
      <line x1="12" y1="17" x2="12" y2="21" />
      <path d="M10 9l2 2 2-2" />
    </svg>
  </div>
);

export const dataAnalyticsFeatures = [
  {
    id: "Digital Experience Analytics",
    title: "Digital Experience Analytics",
    icon: PerformanceIcon,
    // Page A Data
    heading: "See the path. Understand the latency. Optimize the experience.",
    points: [
      "Capture real-time telemetry across users, networks, and cloud edges.",
      "Correlate every hop to pinpoint where latency originates.",
      "Detect and predict performance anomalies before users feel impact.",
      "Automatically optimize paths for the fastest, most resilient access.",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772963859/Digital_Experience_Analytics_j35aqk.jpg",

    // Page B Data
    detailHeading: "Digital Experience Analytics",
    detailIntro:
      "Modern connectivity demands more than up-time it requires realtime intelligence across every hop between users and the applications they rely on. Invisible latency and path inefficiencies degrade experience and slow critical workflows, often without triggering traditional monitoring tools. Performance Insight Analytics delivers full-path visibility, correlating device, network, edge, and SaaS performance to identify root causes instantly. Real-time analytics power adaptive routing and self-healing network paths, ensuring optimal performance for every user, from any location. By merging performance telemetry with security context, the platform empowers teams to understand how policies impact experience, surface anomalies, and prevent performance risks before they affect the business.",
    detailConclusion: <IntegrationsBanner />,
    cards: [
      {
        emoji: "🔍",
        title: "Full-Path Visibility",
        description:
          "Correlate device, network, edge, and SaaS performance into a single view to pinpoint where latency originates no finger pointing or guesswork.",
        stat: "Identify root cause in 70% less time.",
      },

      {
        emoji: "⚡",
        title: "Adaptive Path Optimization",
        description:
          "Continuously test path performance and automatically steer traffic away from congested ISPs, degraded peering points, or slow cloud edges.",
        stat: "Reduce average latency by up to 40%.",
      },
      {
        emoji: "🤖",
        title: " Synthetic Proactive Testing",
        description:
          "Simulate critical user workflows from global vantage points to detect SASE, network, or application failures before they impact production users",
        stat: " Identify 95% of experience-impacting issues pre-production.",
      },
      {
        emoji: "📊",
        title: "Unified Experience Correlation",
        description:
          "Correlate SASE path health, browser telemetry, and synthetic test results into a single operational view for rapid triage and policy validation",

        stat: "Cut mean-time-to-resolution by 45%.",
      },
    ],
    // extraSections: [
    //   {
    //     title: "Full-Path Visibility",
    //     description:
    //       "When users report slowness, teams often waste hours guessing whether the issue is in the endpoint, Wi-Fi, ISP, security layer, or the SaaS service itself. Full-Path Visibility maps the complete route from device to application, correlating every hop into a single narrative. It enables rapid root-cause identification for performance issues, misconfigurations, and ISP congestion.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png", // Placeholder
    //   },
    //   {
    //     title: "AI-Driven Anomaly Detection",
    //     description:
    //       "Small latency spikes or jitter changes can break voice/video, disrupt file uploads, and fragment SaaS workflows—often before monitoring tools detect anything abnormal. AI-Driven Anomaly Detection learns normal behavior per user, region, and application, then flags deviations instantly. It proactively uncovers patterns like packet loss in a specific ISP.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Adaptive Path Optimization",
    //     description:
    //       "Static routing ignores real-time network conditions, leading to congestion, unpredictable packet loss, and degraded SaaS performance. Adaptive Path Optimization continuously tests multiple network paths and automatically shifts traffic to the best-performing route. It intelligently avoids bad peering decisions and oversubscribed ISP segments.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Experience Score & Impact",
    //     description:
    //       "Traditional NPM tools generate metrics that mean nothing to non-technical stakeholders. Experience Score converts packet loss, RTT, and congestion into a single business-relevant index that reflects the user’s real experience. It allows IT and security teams to quantify how performance issues affect productivity.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    // ],
  },
  {
    id: "Platform Performance Analytics",
    title: "Platform Performance Analytics",
    icon: ThreatIcon,
    heading: "Every layer. Every workload. Optimized.",
    points: [
      "Full-stack infrastructure monitoring across compute, storage, network, containers, and cloud.",
      "Deep application visibility across transactions, APIs, microservices, and dependencies.",
      "Data & database observability for latency, throughput, and integrity.",
      "Cross-layer correlation for faster root cause and optimization.",
    ],
    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772963848/Platform_Performance_Analytics_cj2z1g.jpg",

    detailHeading: "Platform Performance Analytics",
    detailIntro: [
      "Modern digital environments span hybrid cloud, containers, serverless, and legacy systems generating massive telemetry that traditional tools can’t unify. Siloed monitoring slows troubleshooting and increases downtime.",
      "Platform Performance Analytics delivers full-stack visibility across infrastructure, applications, and data pipelines in one intelligent layer. By automatically mapping dependencies and correlating metrics in real time, it detects bottlenecks, anomalies, and capacity risks before they impact users.",
      "From Kubernetes optimization to cloud cost control and SLA assurance, the platform turns complex distributed systems into continuously optimized, business-ready infrastructure.",
    ],
    detailConclusion: <IntegrationsBanner />,
    cards: [
      {
        emoji: "🖥️",
        title: "Infrastructure Intelligence",
        description:
          "Full-Stack Infrastructure Monitoring. Monitor servers, VMs, containers, Kubernetes clusters, and cloud resources in real time. Detect CPU spikes, memory leaks, storage bottlenecks, and network congestion before they impact applications.",
        stat: "Reduce infrastructure-related incidents by 40%.",
      },
      {
        emoji: "⚙️",
        title: "Application Performance Deep Dive",
        description:
          "End-to-End Application Monitoring. Track transaction traces, API latency, service dependencies, and microservice performance. Identify slow code paths, thread contention, and resource inefficiencies instantly.",
        stat: "Improve application response times by 30%.",
      },
      {
        emoji: "📊",
        title: "Data & Database Observability",
        description:
          "Data Performance & Integrity Monitoring. Monitor database query performance, replication lag, data pipeline throughput, and ETL workflows. Detect anomalies in data freshness and processing delays before business impact occurs.",
        stat: "Detect data bottlenecks 60% faster.",
      },
      {
        emoji: "🔍",
        title: "Unified Performance Correlation",
        description:
          "Cross-Layer Root Cause Analytics. Correlate infrastructure metrics, application traces, logs, and data signals into a single operational view. Eliminate siloed troubleshooting and accelerate incident resolution.",
        stat: "Cut mean-time-to-resolution by 50%.",
      },
    ],
    // extraSections: [
    //   {
    //     title: "Intelligence Correlation Engine",
    //     description:
    //       "Security teams are overwhelmed by isolated alerts and fragmented data across SIEM, network tools, identity systems, and endpoint platforms. The Intelligence Correlation Engine unifies these signals into a single threat graph, linking behaviors, entities, and context into one coherent story. Instead of investigating thousands of alerts, analysts see who is doing what, where, and why in seconds.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Advanced Threat Hunting Analytics",
    //     description:
    //       "Modern attackers move silently through valid credentials, trusted applications, and normal network paths—far beyond what signature-based tools can detect. Advanced Threat Hunting Analytics uses behavioral anomaly detection to uncover lateral movement, privilege escalation, persistence attempts, and data staging patterns that traditional controls ignore.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Threat Campaign Mapping",
    //     description:
    //       "Threats rarely appear as isolated events—they are part of a larger campaign involving repeated techniques, infrastructure reuse, and coordinated objectives. Threat Campaign Mapping automatically clusters related activities, revealing the attack chain from initial entry to lateral spread and exfiltration attempts.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Automated Investigation & Response",
    //     description:
    //       "Manual investigations slow teams down while attackers move faster. Automated Investigation & Response transforms alert triage into guided, documented findings with root-cause evidence, asset impact, and recommended remediation steps. The system generates narrative reports that can feed into SOAR workflows for semi- or fully automated response.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    // ],
  },
  {
    id: "SecurityRiskAnalytics",
    title: "Security & Risk Analytics",
    icon: IdentityIcon,
    heading: "Every signal. Every threat. Neutralized.",

    points: [
      "Cross-domain telemetry ingestion from endpoints, network, cloud, identity, and applications.",
      "Behavioral analytics & anomaly detection powered by continuous pattern analysis.",
      "Threat correlation & attack path mapping across multi-layer environments.",
      "Real-time incident prioritization with contextual risk scoring and automated enrichment.",
    ],

    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772963841/Security_Risk_Analytics_uu4zms.jpg",

    detailHeading: "Security & Risk Analytics",

    detailIntro: [
      "Threats no longer come from a single perimeter. They span cloud workloads, endpoints, SaaS, identities, and APIs often moving laterally before detection. Alerts alone aren’t enough. Security teams need intelligence.",
      "Security Threat Analytics converts raw telemetry into actionable threat insights. By analyzing network, endpoint, identity, and cloud signals in real time, it detects anomalies, correlates attack patterns, and uncovers advanced threats early.",
      "Instead of siloed alerts, you get contextual, behavior-driven detection delivering unified visibility, faster response, and reduced dwell time across cloud, hybrid, and on prem environments.",
    ],

    detailConclusion: <IntegrationsBanner />,

    cards: [
      {
        emoji: "🛰️",
        title: "Unified Threat Visibility",
        description:
          "Cross-Environment Signal Collection. Aggregate and normalize security data from endpoints, firewalls, cloud platforms, IAM systems, and SaaS applications into a centralized intelligence layer.",
        stat: "Increase threat visibility coverage by 60%.",
      },
      {
        emoji: "🧠",
        title: "Behavioral & Anomaly Detection",
        description:
          "Advanced Threat Detection Analytics. Detect suspicious behavior such as lateral movement, privilege escalation, data exfiltration, and abnormal login patterns using behavioral baselining.",
        stat: "Detect advanced threats 45% faster than signature based tools.",
      },
      {
        emoji: "🔗",
        title: "Attack Path & Lateral Movement Mapping",
        description:
          "Threat Correlation & Kill Chain Analysis. Map attacker progression across users, devices, workloads, and cloud assets. Identify how threats propagate and stop them before escalation.",
        stat: "Reduce dwell time by 50%.",
      },
      {
        emoji: "🚨",
        title: "Intelligent Incident Prioritization",
        description:
          "Contextual Risk Scoring & Response Acceleration. Correlate multiple alerts into high confidence incidents with automated enrichment, reducing noise and enabling security teams to focus on what truly matters.",
        stat: "Cut false positives by 55%.",
      },
    ],
    // extraSections: [
    //   {
    //     title: "Unified Identity Graph",
    //     description:
    //       "Modern identity is fragmented across Okta, Azure AD, LDAP, and dozens of SaaS apps—making privilege risk almost invisible. The Unified Identity Graph builds a single map of every user, role, and entitlement in your environment. It exposes inherited admin paths, shared permissions, and toxic access combinations that don’t show up in logs.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Entitlement Risk Scoring",
    //     description:
    //       "Not all access is equal, and traditional reviews treat every entitlement the same. Risk Scoring analyzes privilege depth, role relevance, and usage patterns to highlight truly dangerous access. It surfaces high-impact issues like dormant admin roles, privilege creep, and over-exposed SaaS permissions.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Access Usage Analytics",
    //     description:
    //       "Most users have far more access than they ever use—and over time, that becomes a silent attack surface. Access Usage Analytics continuously compares granted permissions against real behavior to reveal what’s unused. It empowers least-privilege enforcement based on evidence, not assumptions or manual audits.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Continuous Least-Privilege Automation",
    //     description:
    //       "Manual entitlement cleanup is painful, slow, and often ignored until something breaks. This capability automates least-privilege actions with safe revocations, policy suggestions, and lifecycle alignment. It continuously adjusts permissions for joiners, movers, and leavers so access stays clean over time.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    // ],
  },
  {
    id: "AISystemsAnalytics",
    title: "AI Systems Analytics",
    icon: AIBehaviorIcon,
    heading: "Every model. Every agent. Under control.",

    points: [
      "ML lifecycle observability for data quality, drift, and inference performance.",
      "LLM runtime monitoring for latency, tokens, and output risk.",
      "Agent traceability across decisions, tool calls, and actions.",
      "AI governance & cost analytics across pipelines and deployments.",
    ],

    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772963841/ai_system_se_gydgxa.jpg",

    detailHeading: "AI Systems Analytics",

    detailIntro: [
      "AI systems are no longer experimental they now power critical decisions, automation, and customer experiences. From machine learning pipelines to large language models and autonomous agents, AI introduces probabilistic behavior that traditional monitoring tools cannot measure effectively.",
      "AI Systems Analytics delivers deep observability across models, prompts, and agent workflows. It detects drift, hallucination risk, prompt injection, latency spikes, and token inefficiencies in real time.",
      "By correlating inputs, inference behavior, and decision chains, the platform turns opaque AI systems into measurable, governed, and cost-optimized infrastructure ensuring reliability and control across your entire AI stack.",
    ],

    detailConclusion: <IntegrationsBanner />,

    cards: [
      {
        emoji: "📈",
        title: "ML Model Performance & Drift Monitoring",
        description:
          "Continuous Model Health Analytics. Monitor prediction accuracy, feature drift, data skew, bias indicators, and inference latency across deployed ML models. Detect degradation before business impact.",
        stat: "Reduce model performance degradation incidents by 40%.",
      },
      {
        emoji: "🧩",
        title: "LLM Runtime & Prompt Observability",
        description:
          "Large Language Model Intelligence. Track token usage, response latency, hallucination signals, prompt injection attempts, and output consistency across LLM deployments.",
        stat: "Cut LLM operational costs by 30% through token optimization.",
      },
      {
        emoji: "🔄",
        title: "Agent Framework Traceability",
        description:
          "Autonomous Agent Decision Mapping. Capture multi step reasoning chains, tool invocations, API calls, and execution outcomes to ensure agents behave as intended.",
        stat: "Improve agent reliability by 45%.",
      },
      {
        emoji: "🛡️",
        title: "AI Governance & Risk Analytics",
        description:
          "Responsible AI Control Layer. Enforce guardrails for data privacy, compliance, bias monitoring, and policy adherence across ML, LLMs, and agent systems.",
        stat: "Reduce AI-related compliance risk exposure by 50%.",
      },
    ],

    // extraSections: [
    //   {
    //     title: "Behavioral Baseline Engine",
    //     description:
    //       "Identities behave in patterns: how they authenticate, what they access, and how they use privileges. The Baseline Engine learns these patterns to detect abnormal actions long before traditional alerts fire. It correlates subtle signals like unusual API use or rare cloud activity into meaningful early warnings.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Compromised Identity Detection",
    //     description:
    //       "Attackers don’t always use exploits—today they abuse identity friction to bypass controls. This capability detects early signs of compromise like MFA fatigue, session hijacking, and consent manipulation. It alerts on privilege spikes and risky authentication flows that indicate takeover attempts.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Lateral Movement Correlation",
    //     description:
    //       "When attackers get initial access, they move silently through identity paths—not networks. This card correlates events from SaaS, cloud, endpoints, and identity systems to map that movement. It highlights how privileges are escalated and where attackers pivot in the identity graph.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Insider & Entity Risk Detection",
    //     description:
    //       "Not all threats come from external attackers—insiders and machine identities can cause major damage. This capability detects intent by analyzing unusual file access, large data pulls, and rare API actions. It monitors behavior from non-human identities that often bypass traditional controls.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    // ],
  },
  {
    id: "BusinessOutcomeAnalytics",
    title: "Business Outcome Analytics",
    icon: AIPerformanceIcon,
    heading: "Every metric. Every dollar. Optimized.",

    points: [
      "Cross-domain KPI correlation linking IT, security, AI, and operations to business performance metrics.",
      "Revenue impact analysis tied to latency, downtime, and user experience degradation.",
      "Cost optimization insights across infrastructure, cloud, AI workloads, and security operations.",
      "Executive level dashboards translating technical performance into financial outcomes.",
    ],

    imageUrl:
      "https://res.cloudinary.com/dpn3bkjba/image/upload/v1772963841/Business_Outcome_Analytic_dhptfh.jpg",

    detailHeading: "Business Outcome Analytics",

    detailIntro: [
      "Technology performance only matters if it drives measurable business impact. Uptime, latency, security, and AI efficiency directly influence revenue, customer retention, operational cost, and long-term growth.",
      "Business Outcome Analytics connects technical telemetry to executive KPIs. By correlating platform, security, and AI performance with revenue, conversion rates, service level agreements, and customer experience metrics, the platform transforms operational data into financial insight.",
      "Instead of asking whether systems are simply healthy, organizations gain clarity on how performance is impacting revenue, cost, and risk in real time. From detecting revenue leakage to quantifying ROI on cloud, SASE, and AI investments, the platform enables faster and more data-driven executive decisions.",
    ],

    detailConclusion: <IntegrationsBanner />,

    cards: [
      {
        emoji: "📊",
        title: "KPI-to-Technology Correlation",
        description:
          "Operational Signals to Business Metrics. Correlate application latency, infrastructure health, security incidents, and AI performance with revenue, conversion rates, churn, and SLA compliance.",
        stat: "Improve KPI visibility across IT and business by 60%.",
      },
      {
        emoji: "💰",
        title: "Revenue & Experience Impact Modeling",
        description:
          "Financial Impact Intelligence. Quantify how downtime, performance degradation, or security events affect sales, transaction volume, and customer retention.",
        stat: "Reduce revenue leakage from performance issues by 25%.",
      },
      {
        emoji: "📉",
        title: "ROI & Cost Optimization Analytics",
        description:
          "Technology Investment Optimization. Measure ROI across cloud spend, SASE infrastructure, AI workloads, and security tooling. Identify underutilized resources and optimization opportunities.",
        stat: "Optimize technology spend by 20–30%.",
      },
      {
        emoji: "📈",
        title: "Executive Decision Dashboard",
        description:
          "Board-Ready Performance Intelligence. Deliver real-time, executive level dashboards that translate complex technical data into clear business outcomes and strategic insights.",
        stat: "Accelerate strategic decision-making by 40%.",
      },
    ],

    // extraSections: [
    //   {
    //     title: "Model Quality & Accuracy Scoring",
    //     description:
    //       "Your AI is only as good as the answers it delivers. This engine continuously scores hallucinations, grounding quality, and factual accuracy to reveal how trustworthy your models truly are. You get clear, actionable insight into when quality dips — and why.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png", // Reusing placeholder
    //   },
    //   {
    //     title: "Drift & Behavior Change Detection",
    //     description:
    //       "AI models quietly change over time, often without warning. Drift Detection catches these shifts the moment they appear, from retrieval changes to subtle semantic drift. It helps you preserve consistent AI behavior, even as models, data, and prompts evolve.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Agent & Workflow Observability",
    //     description:
    //       "AI agents don’t just respond — they think, branch, and take actions behind the scenes. Workflow Observability traces every step, revealing reasoning paths, tool calls, and hidden loops. You finally see how your AI works, not just what it outputs.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    //   {
    //     title: "Cost, Latency & Efficiency Optimization",
    //     description:
    //       "AI performance isn’t just about accuracy — it’s also about speed and cost. This layer shows how tokens, APIs, and model choices impact your bottom line. With real-time visibility, you tune AI workloads for faster results and predictable spend.",
    //     imageUrl:
    //       "https://res.cloudinary.com/dpn3bkjba/image/upload/v1763042948/Business_Intelligence_Analytic_gbuvfi.png",
    //   },
    // ],
  },
];
